import React from "react";
import Reveal from "./Reveal";
import { ABOUT_POINTS } from "../mock";

const About = () => {
  return (
    <section id="quienes" className="bg-1 dots py-28" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-14 items-end">
          <Reveal>
            <p className="label">Quiénes somos</p>
            <h2 className="h-section mt-6" data-testid="about-headline">
              Desarrollamos proyectos de eliminación de carbono.
            </h2>
          </Reveal>
          <Reveal delay={150}>
            <p className="text-muted text-lg leading-snug lg:pb-2">
              No compensamos emisiones en otro lugar: retiramos CO₂ de la atmósfera. Energía para la industria y agricultura regenerativa, a medida de cada cliente.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-8">
          {ABOUT_POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 120}>
              <div className="border-t border-line pt-6" data-testid={`about-point-${i}`}>
                <span className="text-green text-sm tracking-widest">0{i + 1}</span>
                <h3 className="text-white font-semibold text-lg mt-3">{p.title}</h3>
                <p className="text-muted leading-snug mt-2">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
